export const environment = {
    development: true,
    VERSION: "0.0.101",
    API_DEFINITION_URL: 'https://dev-spriced-cdbu.alpha.simadvisory.com/api/v1/definition',
    API_DATA_URL: 'https://dev-spriced-cdbu.alpha.simadvisory.com/api/v1/data-api',
    API_FLINK_URL:'https://dev-spriced-cdbu.alpha.simadvisory.com/api/v1/flink/platform',
    URL: 'https://excelplugin.spriced.dev-spriced-cdbu.alpha.simadvisory.com',
    AUTH_URL: 'https://auth.alpha.simadvisory.com',
    CLIENT: "CHN_D_SPRICED_Client",
    REALMS: "D_SPRICED",
    PAGESIZE: 5000,
    PUBLISHRECORD: 500,
    TOTALELEMENTS: 15000,
    VALIDATIONPOPUPLENGTH: 10000,
    RECORD_LIMIT: 50,
    IDP_HINT: 'saml_spriced_dev',
    appUrl:"https://excelplugin.spriced.dev-spriced-cdbu.alpha.simadvisory.com/",
    NX_EXCEL_SERVICE_URL:'https://dev-spriced-cdbu.alpha.simadvisory.com/api/v1/excel_service/write-csv'
}
